export function CheckReport(report) {
    let status = Check(report)
    return status
}

const VARNAMES = {
    ['b5d7b1d3-0d39-11eb-8114-00155d01060e']: '',
    ['70e72664-ddb0-11ed-8761-c85acf022408']: '',
    ['88e0fa65-e328-11ed-8761-c85acf022408']: '',
    ['dc768591-0d39-11eb-8114-00155d01060e']: 'КоличествоИспытаний',
    ['cbdc5ef9-176d-11eb-8116-00155d01060e']: 'Часы',
    ['be506b82-1769-11eb-8116-00155d01060e']: 'Часы',
    ['7dfb247e-0d48-11eb-8114-00155d01060e']: 'КоличествоЧеловекоЧасов',
    ['3fd7613e-0de0-11eb-8114-00155d01060e']: 'КоличествоЧеловекоЧасов',
    ['00b83b6d-1770-11eb-8116-00155d01060e']: 'КоличествоНеисправностей',
    ['5ea47744-bf91-11eb-811e-00155d01060e']: null,
    ['9e5d5835-e349-11ed-8761-c85acf022408']: 'Неисправности',
    ['07fcd944-7ce5-11eb-811b-00155d01060e']: 'Колво',
    ['e932ea24-1cc5-11eb-8116-00155d01060e']: '',
    ['f8c28d9e-1777-11eb-8116-00155d01060e']: '',
    ['43929d70-0d26-11eb-8114-00155d01060e']: '',
    ['1229589b-7d96-11eb-811b-00155d01060e']: null,
    ['5577e2fc-815f-11eb-811b-00155d01060e']: '',
    ['43e8445a-e34a-11ed-8761-c85acf022408']: 'Неисправности',
    ['ab6140b1-7d95-11eb-811b-00155d01060e']: '',
    ['cb6fc894-1449-11eb-8116-00155d01060e']: '',
    ['9a517f43-b39f-11ee-8770-c85acf022408']: '',
    ['be00a980-b39f-11ee-8770-c85acf022408']: '',
    ['0e51d701-b6c3-11ee-8770-c85acf022408']: '',
    ['6c88c8d5-c00d-11ee-8770-c85acf022408']: '',
    ['ae341200-c00d-11ee-8770-c85acf022408']: ''
}
function Check(report) {
    if (report.report_data.length === 0) {
        return false
    } else {
        if (VARNAMES[report.report_guid] === null) {
            return true
        } else {
            let length = report.report_data
            let filtred = report.report_data.filter(element => element[VARNAMES[report.report_guid]] === 0 || element[VARNAMES[report.report_guid]] === null)
            if (length.length === filtred.length) {
                return false
            } else {
                return true
            }
        }
    }
}